export const getters = {
    anyParcelLayerEnabled: (__, _getters) => {
        return _getters.getActivatedLayers
            .find(_getters.isWFSParcelLayer);
    }
};
